module.exports = __webpack_public_path__ + "img/edit-24px.62b807b3.svg";